import { toast } from "react-toastify";
import { convertBase64ToFile } from "../utils";

export const deepfakeService = async (data) => {
  const file = convertBase64ToFile(data?.image, "userImage.jpg");
  const formData = new FormData();
  formData.append("new_face", file, "userImage.jpg");
  formData.append("theme", "video");
  formData.append("gender", "female");
  const randomNumber = Math.floor(Math.random() * 3) + 1;
  formData.append("number", randomNumber);
  formData.append("upscale", "true");
  formData.append("output_type", "s3");
  formData.append("user_id", data.user_id);

  const url = import.meta.env.VITE_DEEPFAKE_URL;

  try {
    const response = await fetch(url, {
      method: "POST",
      headers: {
        accept: "application/json",
      },
      body: formData,
    });

    if (!response.ok) {
      throw new Error(`Error: ${response.statusText}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Deepfake service error:", error);
    toast("Server is down, please try again later");
    throw error; // Re-throw to handle in Camera component
  }
};

export const registerUserService = async (data) => {
  const file = convertBase64ToFile(data?.file, "userImage.jpg");
  const url = import.meta.env.VITE_REGISTER_URL;

  const formData = new FormData();
  formData.append("user_face", file);
  formData.append(
    "attributes",
    JSON.stringify({
      name: data.name,
      gender: data.gender,
    }),
  );

  try {
    const response = await fetch(url, {
      method: "POST",
      body: formData,
    });

    if (!response.ok) {
      throw new Error(`Error: ${response.statusText}`);
    }

    const result = await response.json();
    return result;
  } catch (error) {
    console.error("Register service error:", error);
    toast("Server is down, please try again later");
    throw error; // Re-throw to handle in Camera component
  }
};
